const getFreeTrialConfig = ({
  freeTrialHasEnded,
}: {
  freeTrialHasEnded: boolean
}) => {
  if (freeTrialHasEnded) {
    return {
      background:
        "bg-[linear-gradient(180deg,#4C1278_0%,#082743_40.38%,#0E1524_100%)]",
      titleClassName: "text-white mb-0.25",
      subtitleClassName: "text-onSurface-400",
      logoColor: "#FFEFB3",
      buttonClassName:
        "mt-2 w-fit shrink-0 p-1 sm:mt-0 bg-white text-onSurface-900",
    }
  }

  return {
    background: "bg-[#F1F5F9]",
    titleClassName: "text-onSurface-900 mb-0.25",
    subtitleClassName: "text-onSurface-600",
    logoColor: "#867408",
    buttonClassName:
      "mt-2 w-fit shrink-0 p-1 sm:mt-0 bg-highlight-800 text-white",
  }
}

export { getFreeTrialConfig }
